import { useParams } from 'react-router';

export function useIdParam(paramName: string = 'id'): number {
  const params = useParams();
  if (!(paramName in params))
    throw new Error(`Неверный аргумент: ${paramName}`);

  return Number(params[paramName]);
}
